export enum RegistrationFlow {
  Application = "application",
  Invite = "invite",
  Invalid = "invalid",
}

export const getRegistrationFlow = (search: string): RegistrationFlow => {
  const params = new URLSearchParams(search);
  const token = params.get("token");

  if (!token) {
    return RegistrationFlow.Invalid;
  }

  if (params.get("application") === "true") {
    return RegistrationFlow.Application;
  }

  return RegistrationFlow.Invite;
};
